import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import { formatPrismicImage } from '~/helpers/image-helper';
import { EMPTY_PIXEL } from '~/const/images';
import TitleSection from '~/components/atoms/Editorial/TitleSection.vue';
import SubtitleSection from '~/components/atoms/Editorial/SubtitleSection.vue';
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
import TagList from '~/components/molecules/Editorial/Global/TagList.vue';
export default {
  name: 'TagListImage',
  components: {
    TitleSection,
    SubtitleSection,
    SimpleParagraph,
    TagList
  },
  props: {
    payload: {
      type: Object,
      required: true
    },
    catalog: {
      type: Object,
      required: true
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    title() {
      var _ref5;

      return ((_ref5 = this.payload) != null ? (_ref5 = _ref5.primary) != null ? (_ref5 = _ref5.title) != null ? _ref5[0] : _ref5 : _ref5 : _ref5) || {};
    },

    subtitle() {
      var _ref4;

      return ((_ref4 = this.payload) != null ? (_ref4 = _ref4.primary) != null ? (_ref4 = _ref4.subtitle) != null ? _ref4[0] : _ref4 : _ref4 : _ref4) || {};
    },

    paragraph() {
      var _ref3;

      return (_ref3 = this.payload) != null ? (_ref3 = _ref3.primary) != null ? _ref3.paragraph : _ref3 : _ref3;
    },

    tagList() {
      if (!this.catalog.categories) {
        return null;
      }

      return this.payload.items.reduce((acc, item) => {
        var cat = this.catalog.categories.find((_ref6) => {
          var {
            hash
          } = _ref6;
          return hash === item.hash;
        });
        var small = formatPrismicImage(item.image.url, ['w_80,dpr_2']) || EMPTY_PIXEL;
        var medium = formatPrismicImage(item.image.url, ['w_100,dpr_2']) || EMPTY_PIXEL;
        var large = formatPrismicImage(item.image.url, ['w_140,dpr_2']) || EMPTY_PIXEL;
        var xlarge = formatPrismicImage(item.image.url, ['w_180,dpr_2']) || EMPTY_PIXEL;

        if (cat) {
          acc.push({
            title: item.title || cat.name,
            url: this.buildCategoryUrl(this.locale, cat.slug, cat.hash),
            tagColor: this.payload.primary.tag_color,
            src: "".concat(large),
            srcset: "".concat(small, " 375w, ").concat(medium, " 750w, ").concat(large, " 1440w, ").concat(xlarge, " 1920w,"),
            alt: item.alt || '',
            tracking: {
              data: {
                event_category: item.event_category,
                event_action: item.event_action,
                event_label: item.event_label
              }
            }
          });
        } else {
          var _ref, _ref2;

          acc.push({
            title: item.tag_link_text || '',
            url: ((_ref2 = item) != null ? (_ref2 = _ref2.tag_link) != null ? _ref2.url : _ref2 : _ref2) || '',
            target: (_ref = item) != null ? (_ref = _ref.tag_link) != null ? _ref.target : _ref : _ref,
            tagColor: this.payload.primary.tag_color,
            src: "".concat(large),
            srcset: "".concat(small, " 160w, ").concat(medium, " 200w, ").concat(large, " 280w, ").concat(xlarge, " 360w,"),
            tracking: {
              data: {
                event_category: item.button_event_category || '',
                event_action: item.button_event_action || '',
                event_label: item.button_event_label || ''
              }
            }
          });
        }

        return acc;
      }, []);
    }

  })
};